/**
 * The signed-in identity, cached under one query key so the shell, the sidebar
 * and every page read the same record.
 */
import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/api";
import type { CurrentUser } from "@/models";

export function useCurrentUser(): ReturnType<typeof useQuery<CurrentUser>> {
  return useQuery({
    queryKey: ["me"],
    queryFn: function fetchMe(): Promise<CurrentUser> {
      return apiFetch<CurrentUser>("/me");
    },
  });
}
